import React from 'react';
import { motion } from 'framer-motion';
export function ProcessSection() {
  const steps = [{
    number: '1',
    title: 'Evaluación inicial',
    description: 'Nos conocemos. Escucho tu historia y lo que esperas del proceso.'
  }, {
    number: '2',
    title: 'Plan de trabajo',
    description: 'Definimos objetivos realistas y un plan personalizado.'
  }, {
    number: '3',
    title: 'Herramientas y seguimiento',
    description: 'Te brindo estrategias concretas y te acompaño en el camino.'
  }];
  return <section id="process" className="py-24 bg-gray-900 text-white" data-id="element-192">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-193">
        <div className="text-center mb-16" data-id="element-194">
          <h2 className="font-serif text-3xl sm:text-4xl font-bold mb-4" data-id="element-195">
            Cómo trabajo
          </h2>
          <p className="text-gray-400 text-lg" data-id="element-196">
            Un proceso transparente y colaborativo.
          </p>
        </div>

        <div className="relative" data-id="element-197">
          {/* Connecting line for desktop */}
          <div className="hidden lg:block absolute top-8 left-[15%] right-[15%] h-px bg-gray-700" data-id="element-198" />

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12" data-id="element-199">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: index * 0.2
          }} className="relative flex flex-col items-center text-center" data-id="element-200">
                <div className="w-16 h-16 bg-teal-700 rounded-full flex items-center justify-center mb-6 shadow-lg z-10 border-4 border-gray-900" data-id="element-201">
                  <span className="font-bold text-xl text-white" data-id="element-202">
                    {step.number}
                  </span>
                </div>
                <h3 className="font-serif text-2xl font-bold mb-3 text-white" data-id="element-203">
                  {step.title}
                </h3>
                <p className="text-gray-400 leading-relaxed max-w-xs" data-id="element-204">
                  {step.description}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}